import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable ,Component, OnDestroy, ViewChild } from '@angular/core';
import { BehaviorSubject, catchError, Observable } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService  {
  private user = new BehaviorSubject(null);
  private subMenus = new BehaviorSubject(null);
  private datePicker: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private date: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private smallScreenMenuState: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private nemtCodes = new BehaviorSubject(null);

  constructor(private http : HttpClient) { }

  getUser(): Observable<any> {
    return this.user.asObservable();
  }

  saveUser(user: any) {
    this.user.next(user);
  }

  getSubMenus() {
    return this.subMenus.asObservable();
  }

  saveSubMenus(subMenus: any) {
    this.subMenus.next(subMenus);
  }

  toggleDatePicker(bool: any){
    this.datePicker.next(bool);
  }

  getDatePickerSate(){
    return this.datePicker.asObservable();
  }

  setDate(date: any){
    this.date.next(date);
  }

  getDate(){
    return this.date.asObservable();
  }

  getSmallScreenMenuState(): Observable<any> {
    return this.smallScreenMenuState.asObservable();
  }

  setSmallScreenMenuState(b: any) {
    this.smallScreenMenuState.next(b);
  }

  getNemtCodes(): Observable<any> {
    return this.nemtCodes.asObservable();
  }

  saveNemtCodes(data: any) {
    this.nemtCodes.next(data);
  }

  private unreadNotificationCount = new BehaviorSubject<number>(0);

  getUnreadNotificationCount(): Observable<number> {
    return this.unreadNotificationCount.asObservable();
  }

  setUnreadNotificationCount(count: number) {
    this.unreadNotificationCount.next(count);
    this.updateAppBadge(count);
  }

  decrementUnreadNotificationCount(amount = 1) {
    const current = this.unreadNotificationCount.getValue();
    const next = Math.max(0, (current || 0) - amount);
    this.unreadNotificationCount.next(next);
    this.updateAppBadge(next);
  }

  private updateAppBadge(count: number) {
    if (typeof navigator !== 'undefined') {
      const nav: any = navigator;
      if (typeof nav.setAppBadge === 'function') {
        if (count > 0) {
          nav.setAppBadge(count).catch(() => {});
        } else if (typeof nav.clearAppBadge === 'function') {
          nav.clearAppBadge().catch(() => {});
        }
      }
    }
  }

  private lastNotificationCountRefreshTime = 0;
  private readonly NOTIFICATION_REFRESH_COOLDOWN_MS = 15000; // 15 seconds

  refreshUnreadNotificationCount(force = false) {
    const now = Date.now();
    if (!force && now - this.lastNotificationCountRefreshTime < this.NOTIFICATION_REFRESH_COOLDOWN_MS) {
      return;
    }
    this.lastNotificationCountRefreshTime = now;

    this.getUnReadCount().subscribe({
      next: (res: any) => {
        const count = res?.count ?? res?.unreadCount ?? 0;
        this.unreadNotificationCount.next(count);
        this.updateAppBadge(count);
      },
      error: () => {}
    });
  }

  getNotifications(queryParam?: any) {
    const params = new HttpParams({ fromObject: queryParam });
    return this.http.get(urls.API_URL + urls.NOTIFICATIONS_URL, { params })
      .pipe(catchError(errorHandl));
  }

  getUnReadCount(): Observable<any> {
    return this.http.get(urls.API_URL + urls.NOTIFICATIONS_UNREAD_COUNT)
      .pipe(catchError(errorHandl));
  }

  markNotificationAsRead(id: string): Observable<any> {
    return this.http.patch(`${urls.API_URL}${urls.NOTIFICATIONS_URL}/${id}`, { isRead: true })
      .pipe(catchError(errorHandl));
  }

  markAllAsRead(companyId?: any): Observable<any> {
    const cid = companyId?._id || (typeof companyId === 'string' ? companyId : undefined);
    const body = cid ? { company: cid } : {};
    return this.http.patch(urls.API_URL + urls.NOTIFICATIONS_MARK_ALL_READ, body)
      .pipe(catchError(errorHandl));
  }
}
